import { Shark, Utils } from "shark-mvc";
// import moment from "moment";

import NousCoreModel from "./NousCoreModel";

class Note extends NousCoreModel {
	attachmentGuidList = [];
	body = "";
	taskGuid = "";
	
	__authorName = "";
	// __attachmentList = [];
	// __hasAttachments = false;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		let exportData = super.export();

		exportData.attachmentGuidList = this.exportArrayField("attachmentGuidList");

		return exportData;
	}

	import (data) {
		super.import(data);

		this.__htmlBody = this.body.replace(/\n/g, "<br>");
		// this.__userIsAssignee = Shark.$store.loggedUser.guid === this.assigneeGuid;
		// this.__userIsOwner = Shark.$store.loggedUser.guid === this.createdByGuid;

		// this.__attachmentList = this.attachmentGuidList.map(item => {
		// 	return {
		// 		guid: item.guid,
		// 		renderCSSClassList: "attachment-loading",
		// 	};
		// });

		// this.__hasAttachments = this.attachmentGuidList.length > 0;

		this.parseAuthor();
		// this.parseStatus();
	}

	parseAuthor () {
		if (this.createdByGuid !== "") {
			if (Shark.$store.userList) {
				const author = Utils.safp(Shark.$store.userList, "guid", this.createdByGuid);

				if (author) {
					this.__authorName = author.__fullName;
				}
			}
		}
		else {
			this.__authorName = "--";
		}
	}

	validate () {
		const errors = [];

		if (this.body.trim() === "") {
			errors.push({
				error: "Devi inserire un testo.",
				field: "body",
			});
		}

		return errors;
	}
}

Shark.registerModel("Note", Note);

export default Note;
